/**
 * Checks if given property is a `boolean` type
 * @param prop to be checked
 * @returns true if input is a boolean, false otherwise
 *
 * @author louiiuol
 */
export const isBoolean = (prop: unknown) => typeof prop === 'boolean';
